import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {
    AangeverBurgerlijkeStaat,
    Aangifte, BokkzAlgDataService,
    Heffingskortingen,
    IncomeTaxEntity,
    Loon,
    OmschrijvingEnBedrag
} from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-loon-vroeger',
  templateUrl: './loon-vroeger.component.html',
  styleUrls: ['./loon-vroeger.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        SharedUiButtonModule,
        SharedUiDetailsModule,
        CommonModule,
        SharedUiAlertModule
    ]
})
export class LoonVroegerComponent implements OnInit, OnDestroy {
    @Input() public id!: string;
    @Input() partner = new BehaviorSubject<boolean>(false);

    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    public clientId!: string;

    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = {} as boolean;
    private partnerAangifte = {} as Aangifte

    public aangeverNaam: string | undefined = '';
    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null

    public loonVroeger = {} as FormGroup
    public rechtOpAowAlleenstaande = {} as FormGroup
    public krijgtWajong = {} as FormGroup
    public currentYear: number = new Date().getFullYear();

    public optionsLoonsoort: SelectFormControlItem<string>[] = [
        {value: "11", label: "AOW", disabled: false},
        {value: "17", label: "Pensioen"},
        {value: "18", label: "Lijfrente"},
        {value: "12", label: "WW"},
        {value: "13", label: "WIA/WAO"},
        {value: "14", label: "WAJONG"},
        {value: "15", label: "Ontslag- of transitievergoeding"},
        {value: "16", label: "Levensloopuitkering"},
        {value: "19", label: "Bijstand"},
        {value: "20", label: "Andere uitkeringen"}
    ];

    public optionsJaNee: SelectFormControlItem<boolean | undefined>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"},
    ];

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.loonVroeger = this.fb.group({
            loonVroegereArbeid: this.fb.array<Loon>([]),
        });
        this.rechtOpAowAlleenstaande = this.createRechtOpAowAlleenstaandeGroup();
        this.krijgtWajong = this.createKrijgtWajongGroup();
    }

    get loonVroegereArbeid(): FormArray {
        return this.loonVroeger.get('loonVroegereArbeid') as FormArray;
    }

    addRijLoonVroeger(): void {
        this.loonVroegereArbeid.push(this.createLoonVroegerFormGroup())
    }

    verwijderRijLoonVroeger(index: number): void {
        this.loonVroegereArbeid.removeAt(index);
        this.loonVroeger.updateValueAndValidity()
        this.loonVroeger.markAsDirty()
        this.saveForm();
    }

    createLoonVroegerFormGroup(loon?: Loon): FormGroup {
        return this.fb.group<Loon>(({
            loon: this.fb.group<OmschrijvingEnBedrag>({
                omschrijving: loon ? loon.loon?.omschrijving : undefined,
                bedrag: loon ? loon.loon?.bedrag : undefined
            }),
            loonheffing: loon ? loon.loonheffing : null as unknown as number,
            loonsoort: loon ? loon.loonsoort : null as unknown as string,
        } as Loon));
    }

    public createRechtOpAowAlleenstaandeGroup(rechtAow?: Heffingskortingen) {
        return this.fb.group(({
            rechtOpAowAlleenstaande: rechtAow?.rechtOpAowAlleenstaande ? rechtAow.rechtOpAowAlleenstaande : undefined
        } as Heffingskortingen));
    }

    public createKrijgtWajongGroup(wajong?: Heffingskortingen) {
        return this.fb.group(({
            krijgtWajong: wajong?.krijgtWajong ? wajong?.krijgtWajong : undefined
        } as Heffingskortingen));
    }

    dubbeleBanenOfUitkeringen(): boolean {
        let count = 0;
        const getLength = (path: any): number => path?.length || 0;

        if (this.partnerBoolean) {
            count += getLength(this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitTegenwoordigeDienstbetrekking);
            if (count >= 2) return true;
            count += getLength(this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking);
        } else {
            count += getLength(this.incomeTaxEntity.aangifte?.box1?.belastbaarLoon?.loonUitTegenwoordigeDienstbetrekking);
            if (count >= 2) return true;
            count += getLength(this.incomeTaxEntity.aangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking);
            if (count >= 2) return true;
        }
        return count >= 2;
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.loonVroeger.reset()
                    this.rechtOpAowAlleenstaande.reset()
                    this.krijgtWajong.reset()
                    this.updateForm();
                });
                // this.adjustOptionsBasedOnBirthdate();
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events.pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            if (!this.isDefAangifte) {
                this.dataService.postIncomeTaxEntityMetLoonheffing(this.clientId, false, this.incomeTaxEntity);
            } else {
                this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            }
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.loonVroeger.dirty || this.krijgtWajong.dirty || this.rechtOpAowAlleenstaande.dirty;
    }

    private updateForm(): void {
        let loonLijst = this.aangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking || [];
        let rechtAow = this.aangifte?.heffingskortingen ? this.aangifte.heffingskortingen.rechtOpAowAlleenstaande : undefined
        let wajong = this.aangifte?.heffingskortingen ? this.aangifte?.heffingskortingen?.krijgtWajong : undefined;

        if (this.partnerBoolean) {
            loonLijst = this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking || [];
            rechtAow = this.aangifte?.partnerAangifte?.heffingskortingen ? this.aangifte?.partnerAangifte?.heffingskortingen?.rechtOpAowAlleenstaande : undefined;
            wajong = this.aangifte?.partnerAangifte?.heffingskortingen ? this.aangifte?.partnerAangifte?.heffingskortingen?.krijgtWajong : undefined;
            this.rechtOpAowAlleenstaande.patchValue({rechtOpAowAlleenstaande: rechtAow});
            this.krijgtWajong.patchValue({krijgtWajong: wajong});
        } else {
            loonLijst = this.aangifte?.box1?.belastbaarLoon?.loonUitVroegereDienstbetrekking || [];
            rechtAow = this.aangifte?.heffingskortingen ? this.aangifte?.heffingskortingen?.rechtOpAowAlleenstaande : undefined;
            wajong = this.aangifte?.heffingskortingen ? this.aangifte?.heffingskortingen?.krijgtWajong : undefined;
            this.rechtOpAowAlleenstaande.patchValue({rechtOpAowAlleenstaande: rechtAow});
            this.krijgtWajong.patchValue({krijgtWajong: wajong});
        }

        const formArray = this.loonVroegereArbeid;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > loonLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < loonLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(loonLijst[i]);
            } else {
                const formGroup = this.createLoonVroegerFormGroup(loonLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
            if (!this.partnerBoolean) {
                this.incomeTaxEntity.aangifte = {
                    ...this.aangifte,
                    box1: {
                        ...this.aangifte.box1,
                        belastbaarLoon: {
                            ...this.aangifte.box1?.belastbaarLoon,
                            loonUitVroegereDienstbetrekking: this.loonVroeger.value.loonVroegereArbeid
                        }
                    },
                    heffingskortingen: {
                        krijgtWajong: this.heeftLoonsoort14 ? this.krijgtWajong.get('krijgtWajong')?.value : undefined,
                        rechtOpAowAlleenstaande: this.heeftLoonsoort11 ? this.rechtOpAowAlleenstaande.get('rechtOpAowAlleenstaande')?.value : undefined,
                    }
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            } else {
                this.incomeTaxEntity.aangifte = {
                    ...this.aangifte,
                    partnerAangifte: {
                        ...this.aangifte.partnerAangifte,
                        box1: {
                            ...this.aangifte.partnerAangifte?.box1,
                            belastbaarLoon: {
                                ...this.aangifte.partnerAangifte?.box1?.belastbaarLoon,
                                loonUitVroegereDienstbetrekking: this.loonVroeger.value.loonVroegereArbeid
                            }
                        },
                        heffingskortingen: {
                            krijgtWajong: this.heeftLoonsoort14 ? this.krijgtWajong.get('krijgtWajong')?.value : undefined,
                            rechtOpAowAlleenstaande: this.heeftLoonsoort11 ? this.rechtOpAowAlleenstaande.get('rechtOpAowAlleenstaande')?.value : undefined,
                        }
                    },
                } as Aangifte;
                this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
            }
      this.rechtOpAowAlleenstaande.markAsDirty()
      this.krijgtWajong.markAsDirty()
      this.loonVroeger.markAsDirty()
    }

    get heeftLoonsoort11(): boolean {
        return this.loonVroegereArbeid.value.some((item: any) => item.loonsoort === '11');
    }

    get heeftLoonsoort14(): boolean {
        return this.loonVroegereArbeid.value.some((item: any) => item.loonsoort === '14');
    }

    // private adjustOptionsBasedOnBirthdate() {
    //     const currentDate = new Date();
    //     const geboorteJaarAangever = new Date(this.aangifte?.aangever?.geboortedatum);
    //     const age = currentDate.getFullYear() - geboorteJaarAangever.getFullYear();
    //     const aowLeeftijd = 67; // Pas deze aan volgens de huidige AOW-leeftijd
    //
    //     // Controleer of de gebruiker AOW-gerechtigd is en schakel optie 'AOW' in of uit
    //     this.optionsLoonsoort = this.optionsLoonsoort.map(option => {
    //         if (option.value === "11") {
    //             return {...option, disabled: age < aowLeeftijd}; // Disable als leeftijd onder AOW-leeftijd is
    //         }
    //         return option;
    //     });
    // }
    protected readonly AangeverBurgerlijkeStaat = AangeverBurgerlijkeStaat;
}
